import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { newSeasonFilterStyle } from '../../../services/utils';
import ReactSelect, { components } from 'react-select';
import { setEventStatsYear } from '../../../actions/actions/eventStats';

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <img src={'/img/icons/Polygon.svg'} className={'mr-1'} />
    </components.DropdownIndicator>
  );
};

const PeriodFilterEvent = ({ yearsOptions, setEventStatsYear }) => {
  const currentYear = moment().year();

  const options = yearsOptions
    ? yearsOptions
    : Array.from({ length: currentYear - 2019 + 1 }, (_, i) => {
        const year = currentYear - i;
        return { value: year, label: year };
      });

  const defaultYearOption = options.find((opt) => opt.value === currentYear);

  const handleSelectChange = useCallback((value) => {
    setEventStatsYear([String(value.value)]);
  }, [setEventStatsYear]);

  return (
    <ReactSelect
      onChange={handleSelectChange}
      isClearable={false}
      styles={newSeasonFilterStyle()}
      defaultValue={defaultYearOption}
      options={options}
      components={{
        DropdownIndicator,
        IndicatorSeparator: () => null,
        Input: () => null,
        Placeholder: () => null,
      }}
    />
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
  setEventStatsYear,
};

export default connect(mapStateToProps, mapDispatchToProps)(PeriodFilterEvent);



// WEBPACK FOOTER //
// ./app/components/Filters/EventStats/PeriodFilterEvent.js